import { Injectable } from "@angular/core";
import { AsParametresClient, ServicesClientService } from "../../../val-ammon-services/val-services-lib/src/public-api";
import { ValApiResultat } from "../../../val-ammon-services/val-services-communs-lib/src/public-api";
import { parametresClient } from "../public-api";
import { OAuthService } from "angular-oauth2-oidc";

@Injectable({ providedIn: 'root' })
export class ServicesParametresClient {

    constructor(private servicesClientService: ServicesClientService, private oAuthService: OAuthService) {
    }

    async ChargerParametresClient() {
        if (this.oAuthService.hasValidAccessToken())
            await this.RecupererParametres();
        else
            this.NettoyerParametresClient();
    }

    //Charge les paramètres du client s’ils ne le sont pas encore (lien direct ou rechargement, avant la vue principale).
    //Sans eux, l’en-tête IDENTIFIANT_CLIENT partirait vide. Le code client est celui de la session, comme pour la garde d’authentification
    async AssurerParametresClient() {
        if (parametresClient.identifiant)
            return;

        parametresClient.code ||= sessionStorage.getItem("code_client") ?? "";

        if (parametresClient.code)
            await this.ChargerParametresClient();
    }

    private async RecupererParametres() {
        if (parametresClient.code)
            await this.RecupererParametresClient();
        else
            await this.RecupererLoginUtilisateur();
    }

    private async RecupererParametresClient() {
        let valApiResultat: ValApiResultat<AsParametresClient>;

        try {
            valApiResultat = await this.servicesClientService.RetournerParametresClient();

            if (valApiResultat.status === "success") {
                parametresClient.identifiant = valApiResultat.resultat!.identifiantClient;
                parametresClient.urlApi = valApiResultat.resultat!.urlApi;
                parametresClient.urlBackOffice = valApiResultat.resultat!.urlBackOffice;
                parametresClient.loginUtilisateur = valApiResultat.resultat!.loginUtilisateur;
            }
        }
        catch (erreur) {
        }
    }

    private async RecupererLoginUtilisateur() {
        parametresClient.loginUtilisateur = this.oAuthService.getIdentityClaims ()!["preferred_username"];
    }

    private NettoyerParametresClient() {
        parametresClient.identifiant = "";
        parametresClient.urlApi = "";
        parametresClient.urlBackOffice = "";
        parametresClient.loginUtilisateur = "";
    }
}
